// extracted by mini-css-extract-plugin
export default {"link":"ClientErrorPage_link__Ovk0R","info":"ClientErrorPage_info__yqBNB"};